module.exports = __webpack_public_path__ + "static/img/2.0694a50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fu_shen/2.png
// module id = Kwfv
// module chunks = 0